import { Flex, Text } from "@chakra-ui/react";

// Figma: https://www.figma.com/design/z9Ut4lxLJQZK28vEZiHRwN/Monthly-rewards?node-id=122-6454

export function PriceRow({ retailPrice }: { retailPrice: number | null }) {
  if (retailPrice == null || retailPrice <= 0) return null;
  return (
    <Flex align="center" gap="6px">
      <Text
        fontSize="16px"
        fontWeight={700}
        color="success.500"
        lineHeight={1.3}
      >
        $0.00
      </Text>
    
      <Text
        fontSize="16px"
        fontWeight={700}
        color="white"
        lineHeight={1.3}
        textDecoration="line-through"
      >
        ${retailPrice.toFixed(2)}
      </Text>
    </Flex>
  );
}
